import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AgreeComponent } from '../agree/agree.component';
import { GridaService } from '../service/grida.service';
import { DomSanitizer } from '@angular/platform-browser';
import {Router} from '@angular/router';

declare var MediaRecorder: any;

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent implements OnInit {

  public isRecording = false;
  public mediaRecorder;
  public audioArray = [];
  public image = null;
  public createData = null;
  public insertImage = true;

  sttRequest;

  generateImage: boolean = false;
  generatingImage: boolean = false;
  generateComplete: boolean = false;
  spinnering: boolean = false;

  runCount;

  constructor(
    private dialog: MatDialog,
    private gridaService: GridaService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) { }

  ngOnInit() {
    this.getRunCount();
  }

  public generateImageToVoice() {
    if (!this.isRecording) {
      this.startRecording();
    } else {
      this.timeout();
    }
  }

  public async startRecording() {
    this.isRecording = true;
    const mediaStream: MediaStream = await navigator.mediaDevices.getUserMedia({audio: true});
    this.mediaRecorder = new MediaRecorder(mediaStream);
    this.mediaRecorder.ondataavailable = (event) => {
      this.audioArray.push(event.data);
    };

    this.mediaRecorder.start();
  }

  public timeout() {
    this.generatingImage = true;
    setTimeout(() => {
      this.mediaRecorder.stop();
      setTimeout(() => {
        this.stopRecording();
      }, 100);
    }, 400);
  }

  public stopRecording() {
    const inputBlob = new Blob(this.audioArray, {type: 'audio/mpeg codecs=mp3'});

    this.gridaService.generateImageToVoice(inputBlob).subscribe(result => {
      this.generatingImage = false;

      const value = JSON.parse(atob(result[0].result));
      if (value.sttText === 'null') {
        alert('음성 인식 오류입니다. 다시 시도해주세요.');
        this.mediaRecorder = null;
        this.audioArray = [];
        this.isRecording = false;

        return;
      }
      this.sttRequest = value;
      this.image = this.sanitizer.bypassSecurityTrustUrl('data:image/*;base64, ' + value.imageContent);

      // 리턴 받은 audioContent 변환 후 play
      const valueAudioBinaryString = atob(value.audioContent);
      const valueAudioBytes = new Uint8Array(valueAudioBinaryString.length);
      for (let i = 0; i < valueAudioBinaryString.length; i++) {
        valueAudioBytes[i] = valueAudioBinaryString.charCodeAt(i);
      }
      const valueAudioBlob = new Blob([valueAudioBytes.buffer], {type: 'audio/mp4'});
      const valueAudio = new Audio(URL.createObjectURL(valueAudioBlob));
      valueAudio.play();

      // media 변수 초기화
      this.mediaRecorder = null;
      this.audioArray = [];
      this.isRecording = false;
      this.insertImage = true;

      this.generateImage = true;
      this.addRunCount();
    });
  }

  public retry() {
    this.generateImage = false;
    this.generateComplete = false;
    this.image = null;
    this.getRunCount();
  }

  // create시 mock데이터로 입력
  public create() {
    // const dialog = this.dialog.open(AgreeComponent, {
    //   data: this.sttRequest,
    //   disableClose: true,
    // });
    //
    // dialog.componentInstance.userRegistrationEvent.subscribe(res => {
    // });
    //
    // dialog.afterClosed().subscribe(res => {
    //   if (res) {
    //     this.generateComplete = true;
    //     alert('등록이 완료되었습니다.');
    //   }
    // });
    const registrationRequest = {
      userName: '',
      userPhone: '',
      userEmail: '',
      userOrganization: '',
      prompt: this.sttRequest.sttText,
      translatedPrompt: this.sttRequest.translatedText,
    };
    const imageBlob = this.dataURItoBlob(this.sttRequest.imageContent);
    const imageName = this.sttRequest.tranlatedText;
    const imageFile = new File([imageBlob], imageName, { type: 'image/png' });

    this.spinnering = true;
    this.gridaService.imageRegistration(registrationRequest, imageFile).subscribe(res => {
      this.spinnering = false;
      this.insertImage = false;
      this.createData = res.data;
      alert('그림 등록이 완료되었습니다.');
    });
  }

  public dataURItoBlob(dataURI) {
    const byteString = atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/png' });
    return blob;
  }

  // 임시 다운로드 기능 생성
  public download() {
    const dialog = this.dialog.open(AgreeComponent, {
      data: this.sttRequest,
      disableClose: true,
    });

    dialog.componentInstance.userRegistrationEvent.subscribe(res => {
    });

    dialog.afterClosed().subscribe(res => {
      console.log(res);
      console.log(this.createData);

      this.spinnering = true;

      if (!this.createData) { // 그림을 등록하기 전에 다운로드를 눌렀을때
        const imageBlob = this.dataURItoBlob(this.sttRequest.imageContent);
        const imageName = this.sttRequest.tranlatedText;
        const imageFile = new File([imageBlob], imageName, { type: 'image/png' });
        this.gridaService.imageRegistration(res,  imageFile).subscribe(res => {
          this.spinnering = false;
          window.open(res.data.imageUrl);
          this.router.navigate(['list']);
        });
      } else { // 그림을 등록한 후 다운로드 했을 때
        this.gridaService.updatePost(this.createData.id, res).subscribe(res => {
          this.spinnering = false;
          window.open(res.data.imageUrl);
          this.router.navigate(['list']);
        });
      }
      // if (res) {
      //   this.generateComplete = true;
      //   alert('등록이 완료되었습니다.');
      // }
    });
  }

  public addRunCount() {
    this.gridaService.addRunCount().subscribe(res => {
      console.log(res);
      this.runCount = res.count;
    });
  }

  public getRunCount() {
    this.gridaService.getRunCount().subscribe(res => {
      this.runCount = res.count;
    });
  }

}
